"use client"

import { usePathname } from "next/navigation"
import { createContext, type ReactNode, useContext, useEffect, useState } from "react"

export type SidePanelMode = "overlay" | "default"

type SidePanelContextType = {
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
  mode: SidePanelMode
  setMode: (mode: SidePanelMode) => void
}

export const SidePanelContext = createContext<SidePanelContextType | undefined>(undefined)

export const SidePanelProvider = ({ children }: { children: ReactNode }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [mode, setMode] = useState<SidePanelMode>("overlay")
  const pathname = usePathname()!

  useEffect(() => {
    setIsOpen(false)
  }, [pathname])

  return (
    <SidePanelContext.Provider value={{ isOpen, setIsOpen, mode, setMode }}>
      {children}
    </SidePanelContext.Provider>
  )
}

export const useSidePanel = () => {
  const context = useContext(SidePanelContext)
  if (context === undefined) {
    return {
      isOpen: false,
      setIsOpen: () => {},
      mode: "overlay" as SidePanelMode,
      setMode: () => {},
    }
  }
  return context
}
